import {PREDICTION,ACTUAL,COMBINED,HISTOGRAM_CHART,BAR_CHART,SCATTERPLOT_CHART, LINE_CHART, PARALLEL_COORDINATES_CHART} from './Constants'
import {AXIS_OFF, AXIS_ON, ZAXIS, YAXIS_DATATYPE, XAXIS_DATATYPE} from '../../Globals/Constants'
import  * as React from "react";
import {useState} from 'react';
import * as ReactDOM from 'react-dom';
import '../../../css/graphBorders.css'
import { DropTarget, ConnectDropTarget, DropTargetConnector, DropTargetMonitor ,useDrop} from 'react-dnd';
import ItemTypes from '../../ItemTypes';
import ErrorBoundary from 'react-error-boundary';
import ScatterPlot from '../Charts/ScatterPlot/Scatterplot';
import * as interactfuncs from '../../libtsx/interactfuncs'
import {min as d3min,
    max as d3max,
    schemeCategory10 as d3SchemeCategory10, event as d3event, drag
   } from 'd3'
import { select as d3Select, selectAll as d3SelectAll, event as currentEvent} from 'd3-selection'
import {drag as d3drag} from 'd3-drag'
import ExpectationGraph from './ExpectationGraph'
import MasterGraphConfig from './MasterGraphConfig'
import MasterGlobalGraphConfig from './MasterGlobalGraphConfig'
import {GraphPredictContext}from './GraphPredictContext'
import * as globals from '../../Globals/Globals'
import {ATTRIBUTE_DROP, ATTRIBUTE_HOVER, ATTIBUTE_DEFAULT, ATTRIBUTE_DRAG} from '../../Attributes/Constants'
import {LogEvents} from '../../Globals/Globals'
import {PREDICITON_MODE, NOPREDICITON_MODE} from '../../Globals/Constants'

import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
    ,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, LOG_EVENT_TYPE_CHART_BRUSHING_STARTED,
    LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED} from '../../Globals/LogConstants'
    


function getStyleY(borderColor: string, width: number, height: number): React.CSSProperties {
    return {
        top: 50+'px',
        left: 0.084*height+'px',
        height: 0.792*height,
        width: 40+'px',
        position: 'absolute' as 'absolute',
        boxSizing: 'border-box' as 'border-box',
        borderWidth: 0,
        borderRadius: 5,
        backgroundColor: borderColor,
        borderTopColor: '#bdbdbd',
        borderTopWidth:8,
        borderStyle: 'solid'
    }
  }


function getStyleDrag(borderColor: string, width: number, height: number): React.CSSProperties {
    return {
        top:  0.792*height+ 50 + 5 + 'px',
        left: 0.084*height+'px',
        height: 40+ 'px',
        width: 40+'px',
        position: 'absolute' as 'absolute',
        boxSizing: 'border-box' as 'border-box',
        borderWidth: 0,
        borderRadius: 5,
        borderColor: borderColor,
        borderStyle:'dashed',
    }
  }

  function getStyleYContent(): React.CSSProperties {
    return {
        whiteSpace:'nowrap',
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        top: '85%',
        transform: 'rotate(-90deg)',
    }
  }

  function getStyleDragContent(): React.CSSProperties {
    return {
        alignContent: 'justify',
        top: '45%',
        transform: 'translateY(-50%)',
    }
  }

  function getStyleZContent(): React.CSSProperties {
    return {
        whiteSpace:'nowrap',
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        top: '85%',
        transform: 'rotate(-90deg)',
    }
  }

  function getStyleXContent(): React.CSSProperties {
    return {
        whiteSpace:'nowrap',
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        left: '10%',
        top: '50%',
        transform: 'translateY(-50%)',
    }
  }

  function getStyleX(borderColor: string, width: number, height: number): React.CSSProperties {
    return {
        top:0.93*height+'px',
        left: 0.2*height+'px',
        width:0.78*height, 
        height: 40+'px',
        position: 'absolute' as 'absolute',
        boxSizing: 'border-box' as 'border-box',
        borderWidth: 0,
        borderRadius: 5,
        backgroundColor: borderColor,
        borderRightColor: '#bdbdbd',
        borderRightWidth:8,
        borderStyle: 'solid'

    }

    
  }


  function getStyleZ(borderColor: string, ZUpdate: number, height: number, ): React.CSSProperties {
    return {
        top: 50+'px',
        left: ZUpdate+'px',
        height: 0.792*height,
        width: 40+'px',
        position: 'absolute' as 'absolute',
        boxSizing: 'border-box' as 'border-box',
        borderWidth: 0,
        borderRadius: 5,
        backgroundColor: borderColor,
        borderTopColor: '#bdbdbd',
        borderTopWidth:8,
        borderStyle: 'solid'
    }
  }

 

  

interface  GraphBorderProps{
    width: number
    height: number
    xaxis: string
    yaxis: string
    yaxisStatus: string
    xaxisStatus: string
    idX: string
    idY: string
    idZ: string
    id: string
    datatype:string
   
}
interface YAxisElement {
    type:string
}
interface XAxisElement {
    type:string
}

interface ZAxisElement {
    type:string
}
const GraphBorder: React.FC<GraphBorderProps> = ({ width,height,xaxis,yaxis,yaxisStatus,xaxisStatus,idX,idY,idZ,id,datatype
    }) => {
     

    const [yToolBoxMovement, setyToolBoxMovement] = useState(0)

    const [graphBrushYaxisRefreshOptions, setgraphBrushYaxisRefreshOptions] = useState({
        'id':'0',
        'height':0
    })
    console.log('dropStatedatatype',datatype, datatype)
    var hasOverX, hasOverY, hasOverZ
    const [widthUpdate, setwidthUpdate] = useState(0.8*width)
    const [heightUpdate, setheightUpdate] = useState(0.8*height)
    let borderColorX = ATTIBUTE_DEFAULT
    let borderColorY = ATTIBUTE_DEFAULT
    let borderColorZ = ATTIBUTE_DEFAULT
 
    
    const [ZUpdate, setZUpdate] = useState(height)
    const [transformUpdate, settransformUpdate] = useState("")
    const [changing, setchanging] = useState("")
    var chart
    if(datatype == 'string')
    {
        chart = BAR_CHART
    }
    else if (datatype == 'float')
    {
        chart = HISTOGRAM_CHART
    }
    else if (datatype == 'time')
    {
        chart = LINE_CHART
    }
    const [dropState, setDropState] = useState({
        'xaxisContent':xaxis,
        'yaxisContent':yaxis,
        'zaxisContent':null,
        'xaxisStatus':xaxisStatus,
        'yaxisStatus':yaxisStatus,
        'zaxisStatus':AXIS_OFF,
        'xaxisDataType':datatype,
        'yaxisDataType':'float',
        'invert':false,
        'graphType':chart,
        'parallelCoordinatesXaxis': '',
        'parallelCoordinatesYaxis': '',
        'parallelCoordinatesZaxis': ''
    })

    const [canvasExpectation, setcanvasExpectation] = React.useState({
        'expectation' : 'none',

    });

    React.useEffect(() => {
        
            var coordinates1 = interactfuncs.resizableDiv(id, idX, setwidthUpdate, setheightUpdate, setZUpdate,settransformUpdate, setchanging, setyToolBoxMovement, idZ, false)
            var coordinates2 = interactfuncs.resizableDiv(id, idY, setwidthUpdate, setheightUpdate, setZUpdate, settransformUpdate, setchanging, setyToolBoxMovement, idZ, false)
            var coordinates2 = interactfuncs.resizableDiv(id, idZ, setwidthUpdate, setheightUpdate, setZUpdate, settransformUpdate, setchanging, setyToolBoxMovement, idZ, true)    

    }, []);
   
    const [{isOverY, isOverCurrentY}, Ydrop] = useDrop({
        accept: ItemTypes.Attributes,
        
        drop(itemType, monitor: DropTargetMonitor){
            const item = monitor.getItem();
            var graph:YAxisElement = {
                type:'yAxis'
            }
           

            dropState['yaxisContent'] = item.content
            dropState[YAXIS_DATATYPE] = globals.dataset.datasetTypesMap.get(item.id)
            dropState['yaxisStatus'] = AXIS_ON

            if(globals.histogramPredictionDataset.getPropsMap(id)!= null)
            {
                var propsMap = globals.histogramPredictionDataset.getPropsMap(id)
                propsMap.yaxis=item.content
            }
            else
            {
                var propsMap = globals.histogramPredictionDataset.addPropsMap(id)
                propsMap.yaxis=item.content
               
            }
            var invert =false
            var graphType = ''
            console.log('yaxisStatus yaxisStatus',dropState['yaxisStatus'],dropState['zaxisStatus'],dropState['xaxisStatus'])
            if(dropState['zaxisStatus'] == AXIS_ON )
            {
                graphType = PARALLEL_COORDINATES_CHART
                
            }
            else
            {
                if(dropState['xaxisStatus'] == AXIS_ON && dropState['yaxisStatus'] == AXIS_OFF)
                {
                
                    if(datatype =='string')
                    {
                        graphType = BAR_CHART
                    
                    }
                    else if(datatype =='time')
                    {
                        graphType = LINE_CHART
                    }
                    else
                    {
                        graphType = HISTOGRAM_CHART
                    
                    }
                }
                if(dropState['xaxisStatus'] == AXIS_ON && dropState['yaxisStatus'] == AXIS_ON)
                {
                    console.log('datatype datatype',datatype,dropState['yaxisDataType'])
                    if(dropState[XAXIS_DATATYPE]=='string' && dropState[YAXIS_DATATYPE]=='float')
                    {
                        graphType = BAR_CHART
                        invert = false
                    }
                    else if(dropState[XAXIS_DATATYPE]=='float' && dropState[YAXIS_DATATYPE]=='string')
                    {
                        graphType = BAR_CHART
                        invert = true
                        var temp =  dropState['yaxisContent'] 
                        dropState['yaxisContent']  =  dropState['xaxisContent']
                        dropState['xaxisContent'] = temp

                        var temp =  dropState['yaxisDataType'] 
                        dropState['yaxisDataType']  =  dropState['xaxisDataType']
                        dropState['xaxisDataType'] = temp

                     
                    }
                    else if(dropState[XAXIS_DATATYPE]=='time' && dropState[YAXIS_DATATYPE]=='float')
                    {
                        graphType = LINE_CHART
                    }
                    else if(dropState[XAXIS_DATATYPE]=='float' && dropState[YAXIS_DATATYPE]=='time')
                    {
                        graphType = LINE_CHART
                    }
                    else if(dropState[XAXIS_DATATYPE]=='float' && dropState[YAXIS_DATATYPE]=='float')
                    {
                        graphType = SCATTERPLOT_CHART
                    }
                
                }
            }
            dropState['graphType'] = graphType
            dropState['invert'] = invert
            console.log('dropState',datatype, dropState)
            const graphVis = {...dropState}
            setDropState(graphVis)
           
            return graph
        },
        collect: monitor => ({
            isOverY: monitor.isOver(),
            isOverCurrentY: monitor.isOver({ shallow: true }),
           
          }),
    })

    const [{isOverX, isOverCurrentX}, Xdrop] = useDrop({
        accept: ItemTypes.Attributes,
       
        drop(itemType, monitor: DropTargetMonitor){
            const item = monitor.getItem();
            var graph:XAxisElement = {
                type:'xAxis'
            }
            console.log('globals.dataset.datasetTypesMap.get(item.id)',item.content,globals.dataset.datasetTypesMap.get(item.id))
            dropState['xaxisContent'] = item.content
            dropState[XAXIS_DATATYPE] = globals.dataset.datasetTypesMap.get(item.id)
            dropState['xaxisStatus'] = AXIS_ON


            if(globals.histogramPredictionDataset.getPropsMap(id)!= null)
            {
                var propsMap = globals.histogramPredictionDataset.getPropsMap(id)
                propsMap.xaxis=item.content
            }
            else
            {
                var propsMap = globals.histogramPredictionDataset.addPropsMap(id)
                propsMap.xaxis=item.content
               
            }

            var invert =false
            var graphType = ''
            console.log('yaxisStatus yaxisStatus',dropState['yaxisStatus'],dropState['zaxisStatus'],dropState['xaxisStatus'])
            if(dropState['zaxisStatus'] == AXIS_ON )
            {
                graphType = PARALLEL_COORDINATES_CHART
                
            }
            else
            {
                if(dropState['xaxisStatus'] == AXIS_ON && dropState['yaxisStatus'] == AXIS_OFF)
                {
                
                    if(datatype =='string')
                    {
                        graphType = BAR_CHART
                    
                    }
                    else if(datatype =='time')
                    {
                        graphType = LINE_CHART
                    }
                    else
                    {
                        graphType = HISTOGRAM_CHART
                    
                    }
                }
                if(dropState['xaxisStatus'] == AXIS_ON && dropState['yaxisStatus'] == AXIS_ON)
                {
                    console.log('datatype datatype',datatype,dropState['yaxisDataType'])
                    if( dropState[XAXIS_DATATYPE] =='string' && dropState[YAXIS_DATATYPE]=='float')
                    {
                        graphType = BAR_CHART
                        invert = false
                    }
                    else if(dropState[XAXIS_DATATYPE]=='float' && dropState[YAXIS_DATATYPE]=='string')
                    {
                        graphType = BAR_CHART
                        invert = true
                        var temp =  dropState['yaxisContent'] 
                        dropState['yaxisContent']  =  dropState['xaxisContent']
                        dropState['xaxisContent'] = temp

                        var temp =  dropState['yaxisDataType'] 
                        dropState['yaxisDataType']  =  dropState['xaxisDataType']
                        dropState['xaxisDataType'] = temp

                       
                    }
                    else if(dropState[XAXIS_DATATYPE]=='time' && dropState[YAXIS_DATATYPE]=='float')
                    {
                        graphType = LINE_CHART
                    }
                    else if(dropState[XAXIS_DATATYPE]=='float' && dropState[YAXIS_DATATYPE]=='time')
                    {
                        graphType = LINE_CHART
                    }
                    else if(dropState[XAXIS_DATATYPE]=='float' && dropState[YAXIS_DATATYPE]=='float')
                    {
                        graphType = SCATTERPLOT_CHART
                    }
                
                }
            }
            dropState['graphType'] = graphType
            dropState['invert'] = invert
            console.log('dropState',datatype, dropState)
            const graphVis = {...dropState}
            setDropState(graphVis)
            return graph
        },
        collect: monitor => ({
            isOverX: monitor.isOver(),
            isOverCurrentX: monitor.isOver({ shallow: true }),
          
          }),
        

    })

    const [{isOverZ, isOverCurrentZ}, Zdrop] = useDrop({
        accept: ItemTypes.Attributes,
       
        drop(itemType, monitor: DropTargetMonitor){
            const item = monitor.getItem();
            var graph:ZAxisElement = {
                type:'zAxis'
            }
         
            dropState['zaxisDataType'] = globals.dataset.datasetTypesMap.get(item.id)
            dropState['zaxisStatus'] = AXIS_ON
            dropState['zaxisContent'] = item.content

            if(globals.histogramPredictionDataset.getPropsMap(id)!= null)
            {
                var propsMap = globals.histogramPredictionDataset.getPropsMap(id)
                propsMap.xaxis=item.content
            }
            else
            {
                var propsMap = globals.histogramPredictionDataset.addPropsMap(id)
                propsMap.xaxis=item.content
               
            }
            dropState['graphType'] = PARALLEL_COORDINATES_CHART
         
            console.log('dropState',datatype, dropState)
            const graphVis = {...dropState}
            setDropState(graphVis)
            return graph
        },
        hover(itemType, monitor: DropTargetMonitor){
            const item = monitor.getItem();
            
        },
        collect: monitor => ({
            isOverZ: monitor.isOver(),
            isOverCurrentZ: monitor.isOver({ shallow: true }),
          
          }),
        

    })

   
    let hovered = false
    if(isOverX)
    {
        borderColorX = ATTRIBUTE_HOVER
       
    }
    else
    {   
       
    }
    if(isOverY)
    {
        console.log('isOverY',isOverY,isOverZ,isOverX)
        borderColorY = ATTRIBUTE_HOVER
       
    }
    else
    {
     
        
    }
    if(isOverZ)
    {
        borderColorZ = ATTRIBUTE_HOVER
       
    }
    else
    {
       
   
    }
        

    
   



    const lablesStyle = {
     'fontSize':'50%'
    }
    const [YBorderPredictionstyleUpdate, setYBorderPredictionstyleUpdate] = useState({
        'fontSize':'50%'
    })
    
   
    
    
    console.log('yaxisStatus zaxisStatus',  dropState['graphType'], globals.dataset.attributes_content[dropState['xaxisContent']])


    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
    if(logevents)
    {
        if(globals.logEventsChartIds.includes(id+dropState['graphType']))
        {

        }
        else
        {
            var eventlog = LogEvents.addEvent(id,  dropState['graphType'], null, LOG_EVENT_TYPE_CHART_CREATED , null, null, dropState['xaxisContent'], dropState['yaxisContent'], null)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
            globals.logEventsChartIds.push(id+dropState['graphType'])
        }
      
    }

    if( dropState['graphType'] == PARALLEL_COORDINATES_CHART)
    {
        var xmarkProp={
            backgroundColor: borderColorY,
        }
        var initGraphOptions;
        if(globals.datasetMode.mode == PREDICITON_MODE)
        {

            initGraphOptions = PREDICTION
        }
        else
        {
            initGraphOptions = ''
        }

        console.log('globals.histogramPredictionDataset',globals.histogramPredictionDataset, graphBrushYaxisRefreshOptions,  dropState['graphType'])

        
        return (
        <>
         
             <GraphPredictContext.Provider graphType={ dropState['graphType']} initGraphOptions={initGraphOptions}>
                <MasterGraphConfig masterid ={id} id={id+'_mastergraphconfig'} valueChangeHandler={this.valueChangeHandler} width={widthUpdate} height={heightUpdate} yToolBoxMovement={yToolBoxMovement} graphType={ dropState['graphType']}></MasterGraphConfig>
                    
             
                <div className={'dragMe'} style={getStyleDrag(borderColorY,width,height)} >
                <svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 26 26" enable-background="new 0 0 26 26" style={xmarkProp}>
                    <path d="M 12.8125 0 C 12.7375 0.0125 12.64375 0.04375 12.59375 0.09375 C 12.49375 0.19375 9.9125 2.6 8.3125 5 C 8.2125 5.2 8.2125 5.39375 8.3125 5.59375 C 8.4125 5.89375 8.6125 6 8.8125 6 L 11 6 L 11 11 L 6 11 L 6 8.8125 C 6 8.6125 5.8875 8.4125 5.6875 8.3125 C 5.4875 8.2125 5.2 8.2125 5 8.3125 C 2.6 9.9125 0.19375 12.49375 0.09375 12.59375 C 0.09375 12.69375 9.2518585e-18 12.9 0 13 C 0 13.1 -0.00625 13.30625 0.09375 13.40625 C 0.19375 13.50625 2.5 16.0875 5 17.6875 C 5.2 17.7875 5.4875 17.7875 5.6875 17.6875 C 5.8875 17.5875 6 17.3875 6 17.1875 L 6 15 L 11 15 L 11 20 L 8.8125 20 C 8.6125 20 8.4125 20.1125 8.3125 20.3125 C 8.2125 20.5125 8.2125 20.70625 8.3125 20.90625 C 9.9125 23.30625 12.49375 25.7125 12.59375 25.8125 C 12.69375 25.9125 12.8 25.90625 13 25.90625 C 13.2 25.90625 13.30625 25.9125 13.40625 25.8125 C 13.50625 25.7125 16.0875 23.40625 17.6875 20.90625 C 17.7875 20.80625 17.7875 20.5125 17.6875 20.3125 C 17.5875 20.1125 17.3875 20 17.1875 20 L 15 20 L 15 15 L 20 15 L 20 17.1875 C 20 17.3875 20.1125 17.5875 20.3125 17.6875 C 20.5125 17.7875 20.70625 17.7875 20.90625 17.6875 C 23.30625 16.0875 25.7125 13.50625 25.8125 13.40625 C 25.9125 13.30625 25.90625 13.2 25.90625 13 C 25.90625 12.8 25.9125 12.69375 25.8125 12.59375 C 25.7125 12.49375 23.40625 9.9125 20.90625 8.3125 C 20.70625 8.2125 20.5125 8.2125 20.3125 8.3125 C 20.1125 8.4125 20 8.6125 20 8.8125 L 20 11 L 15 11 L 15 6 L 17.1875 6 C 17.3875 6 17.5875 5.8875 17.6875 5.6875 C 17.7875 5.4875 17.7875 5.29375 17.6875 5.09375 C 16.0875 2.69375 13.50625 0.2875 13.40625 0.1875 C 13.30625 0.0875 13.1 0 13 0 C 12.95 0 12.8875 -0.0125 12.8125 0 z"/>
                </svg>
                </div> 


                    <ExpectationGraph id={id} width={widthUpdate} height={heightUpdate}
                     xaxis={globals.dataset.attributes_content[dropState['xaxisContent']]} yaxis={globals.dataset.attributes_content[dropState['yaxisContent']] == undefined ? 'Count':globals.dataset.attributes_content[dropState['yaxisContent']]} zaxis={globals.dataset.attributes_content[dropState['zaxisContent']]} 
                     xaxisStatus={dropState['xaxisStatus']} yaxisStatus={dropState['yaxisStatus']}  zaxisStatus={dropState['zaxisStatus']}
                     changing={changing} transform={transformUpdate}  graphType={ dropState['graphType']}  brushValueOptions={graphBrushYaxisRefreshOptions} invert={ dropState['invert']}> </ExpectationGraph>
              
                <div className={idX+' '+'dropX'} ref={Xdrop} style={getStyleX(borderColorX,width,height)} >
                    <div id={idX+"content"} className={idX+"content"}style={getStyleXContent()}>
                        {dropState['xaxisContent']}
                    </div>
                </div> 
    
                <div className={idZ+' '+'dropZ'} ref={Zdrop} style={getStyleZ(borderColorZ,ZUpdate,height)} >
                    <div id={idZ+"content"} className={idZ+"content"}style={getStyleZContent()}>
                        {'zAxis'}
                    </div>
                </div> 
                
            </GraphPredictContext.Provider>
            
        </>
          );
    }
    else
    {
        console.log('globals.histogramPredictionDataset',globals.histogramPredictionDataset, graphBrushYaxisRefreshOptions)
        return (
        <>
         
             <GraphPredictContext.Provider graphType={ dropState['graphType']}>
                <MasterGraphConfig masterid ={id} id={id+'_mastergraphconfig'} valueChangeHandler={this.valueChangeHandler} width={widthUpdate} height={heightUpdate} yToolBoxMovement={yToolBoxMovement} graphType={ dropState['graphType']}></MasterGraphConfig>
                    
                <div className={idY+' '+'dropY'} ref={Ydrop} style={getStyleY(borderColorY,width,height)} >
                    <div id={idY+"content"} className={idY+"content"} style={getStyleYContent()}>
                        {dropState['yaxisContent']}
                    </div>
                </div> 

                <div className={'dragMe'} style={getStyleDrag(borderColorY,width,height)} >
                <svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 26 26" enable-background="new 0 0 26 26">
                    <path d="M 12.8125 0 C 12.7375 0.0125 12.64375 0.04375 12.59375 0.09375 C 12.49375 0.19375 9.9125 2.6 8.3125 5 C 8.2125 5.2 8.2125 5.39375 8.3125 5.59375 C 8.4125 5.89375 8.6125 6 8.8125 6 L 11 6 L 11 11 L 6 11 L 6 8.8125 C 6 8.6125 5.8875 8.4125 5.6875 8.3125 C 5.4875 8.2125 5.2 8.2125 5 8.3125 C 2.6 9.9125 0.19375 12.49375 0.09375 12.59375 C 0.09375 12.69375 9.2518585e-18 12.9 0 13 C 0 13.1 -0.00625 13.30625 0.09375 13.40625 C 0.19375 13.50625 2.5 16.0875 5 17.6875 C 5.2 17.7875 5.4875 17.7875 5.6875 17.6875 C 5.8875 17.5875 6 17.3875 6 17.1875 L 6 15 L 11 15 L 11 20 L 8.8125 20 C 8.6125 20 8.4125 20.1125 8.3125 20.3125 C 8.2125 20.5125 8.2125 20.70625 8.3125 20.90625 C 9.9125 23.30625 12.49375 25.7125 12.59375 25.8125 C 12.69375 25.9125 12.8 25.90625 13 25.90625 C 13.2 25.90625 13.30625 25.9125 13.40625 25.8125 C 13.50625 25.7125 16.0875 23.40625 17.6875 20.90625 C 17.7875 20.80625 17.7875 20.5125 17.6875 20.3125 C 17.5875 20.1125 17.3875 20 17.1875 20 L 15 20 L 15 15 L 20 15 L 20 17.1875 C 20 17.3875 20.1125 17.5875 20.3125 17.6875 C 20.5125 17.7875 20.70625 17.7875 20.90625 17.6875 C 23.30625 16.0875 25.7125 13.50625 25.8125 13.40625 C 25.9125 13.30625 25.90625 13.2 25.90625 13 C 25.90625 12.8 25.9125 12.69375 25.8125 12.59375 C 25.7125 12.49375 23.40625 9.9125 20.90625 8.3125 C 20.70625 8.2125 20.5125 8.2125 20.3125 8.3125 C 20.1125 8.4125 20 8.6125 20 8.8125 L 20 11 L 15 11 L 15 6 L 17.1875 6 C 17.3875 6 17.5875 5.8875 17.6875 5.6875 C 17.7875 5.4875 17.7875 5.29375 17.6875 5.09375 C 16.0875 2.69375 13.50625 0.2875 13.40625 0.1875 C 13.30625 0.0875 13.1 0 13 0 C 12.95 0 12.8875 -0.0125 12.8125 0 z"/>
                </svg>
                   
                </div> 

               
                    <ExpectationGraph id={id} width={widthUpdate} height={heightUpdate} 
                    xaxis={globals.dataset.attributes_content[dropState['xaxisContent']]} yaxis={globals.dataset.attributes_content[dropState['yaxisContent']] == undefined ? 'Count': globals.dataset.attributes_content[dropState['yaxisContent']]} zaxis={globals.dataset.attributes_content[dropState['zaxisContent']]} 
                    xaxisStatus={dropState['xaxisStatus']} yaxisStatus={dropState['yaxisStatus']} zaxisStatus={dropState['zaxisStatus']}  
                    changing={changing} transform={transformUpdate}  graphType={ dropState['graphType']}  brushValueOptions={graphBrushYaxisRefreshOptions} invert={ dropState['invert']}> </ExpectationGraph>
              
                <div className={idX+' '+'dropX'} ref={Xdrop} style={getStyleX(borderColorX,width,height)} >
                    <div id={idX+"content"} className={idX+"content"}style={getStyleXContent()}>
                        {dropState['xaxisContent']}
                    </div>
                </div> 
    
                <div className={idZ+' '+'dropZ'} ref={Zdrop} style={getStyleZ(borderColorZ,ZUpdate,height)} >
                    <div id={idZ+"content"} className={idZ+"content"}style={getStyleZContent()}>
                        {dropState['zaxisContent']}
                    </div>
                </div> 
                
            </GraphPredictContext.Provider>
            
        </>
          );
    }
  
      
}
export default GraphBorder

{/* <svg>
     <text id="operator" transform="matrix(1.0754 0 0 1 10.2568 16.3802)" className="st2 st4">{yaxisUpdate}</text>
           
<text id="operator" transform="matrix(1.0754 0 0 1 10.2568 16.3802)" className="st2 st4">{yaxisUpdate}</text>
<text id="y-axis" transform="matrix(-5.773181e-07 -1 1 -5.773181e-07 23.9801 177.9186)" className="st2 st3">{yaxisUpdate}</text>
<rect ref ={drop} x="6.8" y="31" className="st0" width="30" height="158.4" style={ style }/>
{graph}
</svg> */}